// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthBar_container__2Iq-u","inner":"AuthBar_inner__1bRc2","avatar":"AuthBar_avatar__1i31x"};